import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { H7 } from 'foundations-components/transitional/components/H7';
import { View } from 'foundations-components/transitional/components/View';
import { ViewController } from 'foundations-components/transitional/components/ViewController';
import ContentOverview from './ContentOverview';
import SectionHeading from '../../../components/SectionHeading';
import { useMediaQuery } from '../../../utils/Styling';
import { EnrollLessonButton, EnrollTrackButton } from '../../userProgress/components/EnrollButton';
import { ModalTileSection } from './ModalTileSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BackgroundWrapper = ({
  children,
  isPlaylistOverview
}) => {
  if (isPlaylistOverview) {
    return /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-recessed",
      borderRadius: "300",
      padding: "800",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export const OverviewModalDescriptionSection = ({
  title,
  description,
  duration,
  enrollToUrl,
  selectedLanguage,
  availableLanguages,
  onChangeSelectedLanguage,
  contentList,
  hasCertificate,
  hasStudyGuide,
  isPlaylistOverview,
  type,
  id,
  onEnroll
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsxs(ModalTileSection, {
      padding: "0",
      paddingBlockStart: "800",
      children: [/*#__PURE__*/_jsx(Text, {
        as: isMobile ? 'h4' : 'h2',
        marginBlockEnd: "400",
        typography: "heading-600",
        children: title
      }), type === 'TRACK' ? /*#__PURE__*/_jsx(EnrollTrackButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll,
        to: enrollToUrl
      }) : /*#__PURE__*/_jsx(EnrollLessonButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll,
        to: enrollToUrl
      })]
    }), /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        "data-test-id": type === 'LESSON' ? 'lesson-details' : 'course-details',
        paddingBlockEnd: "400",
        paddingBlockStart: "800",
        children: type === 'LESSON' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.overviewModal.lessonDetails"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.overviewModal.courseDetails"
        })
      }), /*#__PURE__*/_jsx(BackgroundWrapper, {
        isPlaylistOverview: !!isPlaylistOverview,
        children: /*#__PURE__*/_jsxs(CardWrapper, {
          marginBlockEnd: "0",
          children: [/*#__PURE__*/_jsxs(ModalTileSection, {
            paddingBlockEnd: "600",
            children: [/*#__PURE__*/_jsx(H7, {
              paddingBlockEnd: "200",
              children: duration
            }), description]
          }), availableLanguages && availableLanguages.length > 0 && /*#__PURE__*/_jsx(ModalTileSection, {
            paddingBlockEnd: "400",
            children: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(H7, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyComponents.overviewModal.languagesAvailable"
                })
              }), /*#__PURE__*/_jsx(ViewController, {
                "data-test-id": "language-view-controller",
                onChange: onChangeSelectedLanguage,
                options: availableLanguages.map(lang => ({
                  text: lang.toUpperCase(),
                  value: lang
                })),
                size: "extra-small",
                value: selectedLanguage
              })]
            })
          }), type !== 'SHORT_FORM_CONTENT' && /*#__PURE__*/_jsxs(ModalTileSection, {
            children: [/*#__PURE__*/_jsx(H7, {
              marginBlockEnd: "100",
              marginBlockStart: "300",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyComponents.overviewModal.includes"
              })
            }), /*#__PURE__*/_jsx(ContentOverview, {
              content: contentList,
              hasCertificate: hasCertificate,
              hasStudyGuide: hasStudyGuide
            })]
          })]
        })
      })]
    })]
  });
};
export default OverviewModalDescriptionSection;